import RadioInput from "@/components/form/radio/RadioInput";
import en from "@/localization/en.json";
import { PropTypes } from "prop-types";
import Styles from "./modal.module.css";

function SortModal({ sortData, onChange, value: defaultOption }) {
  return (
    <div>
      <input type="checkbox" id="sort-modal" className="modal-toggle" />
      <div className="modal">
        <div className={`${Styles.modal_box} modal-box relative rounded-0`}>
          <div className="flex justify-between items-center mb-9">
            <p className="text-[#414E5F] text-[1.063rem] font-semibold">
              {en["common.sort_by"]}
            </p>
            <label htmlFor="sort-modal" className="font-bold text-lg">
              ✕
            </label>
          </div>

          <div>
            {sortData.map((option) => (
              <RadioInput
                key={option.value}
                value={option.value}
                label={option.label}
                name="sort"
                onChange={onChange}
                defaultValue={defaultOption?.value}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SortModal;

SortModal.propTypes = {
  sortData: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.object,
};
